import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LucideNavIcons } from '../icons/lucideNavIcons';
import { USER_ROLES } from '../constants';

export const useSidebarData = () => {
  const { t } = useTranslation('sidebar');

  return useMemo(
    () => [
      {
        label: t('projects'),
        url: '/projects',
        icon: LucideNavIcons.Projects,
        isStrokeIcon: true,
        permissions: [
          USER_ROLES.GLOBAL_USER,
          USER_ROLES.GLOBAL_ADMIN,
          USER_ROLES.ROLE_CUSTOMER,
          USER_ROLES.COMPANY_ADMIN,
        ],
      },
      {
        label: t('customers'),
        url: '/customers',
        icon: LucideNavIcons.Customers,
        isStrokeIcon: true,
        permissions: [USER_ROLES.GLOBAL_ADMIN],
      },
      {
        label: t('users'),
        url: '/users',
        icon: LucideNavIcons.Users,
        isStrokeIcon: true,
        permissions: [USER_ROLES.GLOBAL_ADMIN],
      },
      {
        label: t('tools'),
        icon: LucideNavIcons.Tools,
        isStrokeIcon: true,
        permissions: [USER_ROLES.GLOBAL_USER, USER_ROLES.GLOBAL_ADMIN],
        selectedRoutes: ['/playground', '/media-studio'],
        children: [
          {
            label: t('aiPlayground'),
            url: '/playground',
            icon: LucideNavIcons.AiPlayground,
            isStrokeIcon: true,
            permissions: [USER_ROLES.GLOBAL_USER, USER_ROLES.GLOBAL_ADMIN],
          },
          {
            label: t('mediaStudio'),
            url: '/media-studio',
            icon: LucideNavIcons.MediaStudio,
            isStrokeIcon: true,
            permissions: [USER_ROLES.GLOBAL_USER, USER_ROLES.GLOBAL_ADMIN],
          },
        ],
      },
      {
        label: t('projectRequest'),
        url: '/project-request',
        icon: LucideNavIcons.ProjectRequest,
        isStrokeIcon: true,
        permissions: [
          USER_ROLES.GLOBAL_USER,
          USER_ROLES.GLOBAL_ADMIN,
          USER_ROLES.ROLE_CUSTOMER,
          USER_ROLES.COMPANY_ADMIN,
        ],
      },
      {
        label: t('settings'),
        url: '/settings/id8',
        icon: LucideNavIcons.Settings,
        isStrokeIcon: true,
        selectedRoutes: [
          '/settings/sonar',
          '/settings/resonance',

          '/settings/scout',
          '/settings/scout/add',
          '/settings/scout/edit',

          '/settings/id8',
          '/settings/id8/',
          '/settings/id8/create-agent',
          '/settings/id8/edit-agent/:id',

          '/settings/activ8',
          '/settings/media-studio',
        ],
        permissions: [USER_ROLES.GLOBAL_ADMIN],
      },
    ],
    [t],
  );
};
